<template>
  <div>
    <banner-image :content="content" />
  </div>
</template>

<script>
  import Image from '../image/Image'
  import { Props, Computed } from '../../assets/js/mixins';

  export default {
    mixins: [Props, Computed],
    data() {
      return {
      }
    },
    components: {
      'banner-image': Image
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/banner/Banner.vue